// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/assets/bg_footer.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Container*/
#footer-container {
    width: 100%;

    display: flex;
    flex-direction: column;
    /*border: 1px solid black;*/
}

/*Section 1*/
#question-container {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 80px;
    font-size: 1.3em;
    font-weight: bold;
    color: #012D26;
    background-color: #D7ECE1;

    /*border: 1px solid aqua;*/
}

/*Section 2*/
#company-location-container {
    width: 75%;
    height: 600px;
    padding-left: 12.5%;
    padding-right: 12.5%;

    display: flex;
    justify-content: flex-start;
    color: white;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

#company-location-component {
    width: 60%;
    max-width: 700px;
    height: 100%;

    /*border: 1px solid aqua;*/
}

#company-location-title {
    display: flex;
    align-items: center;
    width: 100%;
    height: 30%;

    font-size: 2em;

    /*border: 1px solid green;*/
}

#logo-sm {
    width: 60px;
    height: 60px;
}

.company-location-office {
    font-size: 1em;
    margin-bottom: 5%;
    /*border: 1px solid purple;*/
}

#company-location-map {
    margin-top: 50px;
    width: 40%;
    min-width: 300px;
    max-width: 450px;
    height: 510px;
    /*border: 1px solid aqua;*/
}

#map-image {
    width: 100%;
    height: 100%;
}

@media only screen and (max-width: 1100px) {
    #question-container {
        width: 100%;
        padding: 0;
        margin: 0;
    }

    #company-location-container {
        width: 100%;
        padding: 0;

        height: auto;
        display: flex;
        flex-direction: column;
    }

    #company-location-component {
        width: 90%;
        margin: 0 5%;
    }

    #logo-sm {
        width: 70px;
        height: 75px;
        margin-bottom: 15px;
    }

    #company-location-title {
        display: flex;
        width: 100%;
        flex-direction: column;
        align-items: flex-start;
        font-size: 1.5em;
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .company-location-office {
        width: 100%;
        margin-bottom: 45px;
        font-size: 1.3em;
    }

    #company-location-map {
        width: 50%;
        max-width: none;
        min-width: auto;
        padding: 0;
        margin: 15px 0 50px 7%;
    }
}

@media only screen and (max-width: 600px) {
    #company-location-title {
        font-size: 1em;
    }

    .company-location-office {
        font-size: 0.8em;
    }

    #company-location-map {
        width: 75%;
        max-width: none;
        min-width: auto;
        padding: 0;
        margin: 15px 0 50px 7%;
    }
}

@media only screen and (max-width: 400px) {
    #question-container {
        font-size: 0.6em;
        height: 45px;
    }

    #company-location-map {
        width: 86%;
        height: 350px;
        max-width: none;
        min-width: auto;
        padding: 0;
        margin: 15px 0 50px 7%;
    }
}

@media only screen and (max-width: 200px) {
    #question-container {
        font-size: 0.45em;
        height: 35px;
    }
}`, "",{"version":3,"sources":["webpack://./src/App/Component/Footer/style.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;IACI,WAAW;;IAEX,aAAa;IACb,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,yBAAyB;;IAEzB,0BAA0B;AAC9B;;AAEA,YAAY;AACZ;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,oBAAoB;;IAEpB,aAAa;IACb,2BAA2B;IAC3B,YAAY;IACZ,sBAAsB;IACtB,4BAA4B;IAC5B,yDAAgE;AACpE;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,YAAY;;IAEZ,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,WAAW;;IAEX,cAAc;;IAEd,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;QACX,UAAU;QACV,SAAS;IACb;;IAEA;QACI,WAAW;QACX,UAAU;;QAEV,YAAY;QACZ,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,WAAW;QACX,sBAAsB;QACtB,uBAAuB;QACvB,gBAAgB;QAChB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,eAAe;QACf,eAAe;QACf,UAAU;QACV,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,eAAe;QACf,eAAe;QACf,UAAU;QACV,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,aAAa;QACb,eAAe;QACf,eAAe;QACf,UAAU;QACV,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,YAAY;IAChB;AACJ","sourcesContent":["/*Container*/\r\n#footer-container {\r\n    width: 100%;\r\n\r\n    display: flex;\r\n    flex-direction: column;\r\n    /*border: 1px solid black;*/\r\n}\r\n\r\n/*Section 1*/\r\n#question-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n    width: 100%;\r\n    height: 80px;\r\n    font-size: 1.3em;\r\n    font-weight: bold;\r\n    color: #012D26;\r\n    background-color: #D7ECE1;\r\n\r\n    /*border: 1px solid aqua;*/\r\n}\r\n\r\n/*Section 2*/\r\n#company-location-container {\r\n    width: 75%;\r\n    height: 600px;\r\n    padding-left: 12.5%;\r\n    padding-right: 12.5%;\r\n\r\n    display: flex;\r\n    justify-content: flex-start;\r\n    color: white;\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n    background-image: url('../../../../public/assets/bg_footer.jpg');\r\n}\r\n\r\n#company-location-component {\r\n    width: 60%;\r\n    max-width: 700px;\r\n    height: 100%;\r\n\r\n    /*border: 1px solid aqua;*/\r\n}\r\n\r\n#company-location-title {\r\n    display: flex;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 30%;\r\n\r\n    font-size: 2em;\r\n\r\n    /*border: 1px solid green;*/\r\n}\r\n\r\n#logo-sm {\r\n    width: 60px;\r\n    height: 60px;\r\n}\r\n\r\n.company-location-office {\r\n    font-size: 1em;\r\n    margin-bottom: 5%;\r\n    /*border: 1px solid purple;*/\r\n}\r\n\r\n#company-location-map {\r\n    margin-top: 50px;\r\n    width: 40%;\r\n    min-width: 300px;\r\n    max-width: 450px;\r\n    height: 510px;\r\n    /*border: 1px solid aqua;*/\r\n}\r\n\r\n#map-image {\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n@media only screen and (max-width: 1100px) {\r\n    #question-container {\r\n        width: 100%;\r\n        padding: 0;\r\n        margin: 0;\r\n    }\r\n\r\n    #company-location-container {\r\n        width: 100%;\r\n        padding: 0;\r\n\r\n        height: auto;\r\n        display: flex;\r\n        flex-direction: column;\r\n    }\r\n\r\n    #company-location-component {\r\n        width: 90%;\r\n        margin: 0 5%;\r\n    }\r\n\r\n    #logo-sm {\r\n        width: 70px;\r\n        height: 75px;\r\n        margin-bottom: 15px;\r\n    }\r\n\r\n    #company-location-title {\r\n        display: flex;\r\n        width: 100%;\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n        font-size: 1.5em;\r\n        margin-top: 20px;\r\n        margin-bottom: 20px;\r\n    }\r\n\r\n    .company-location-office {\r\n        width: 100%;\r\n        margin-bottom: 45px;\r\n        font-size: 1.3em;\r\n    }\r\n\r\n    #company-location-map {\r\n        width: 50%;\r\n        max-width: none;\r\n        min-width: auto;\r\n        padding: 0;\r\n        margin: 15px 0 50px 7%;\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 600px) {\r\n    #company-location-title {\r\n        font-size: 1em;\r\n    }\r\n\r\n    .company-location-office {\r\n        font-size: 0.8em;\r\n    }\r\n\r\n    #company-location-map {\r\n        width: 75%;\r\n        max-width: none;\r\n        min-width: auto;\r\n        padding: 0;\r\n        margin: 15px 0 50px 7%;\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 400px) {\r\n    #question-container {\r\n        font-size: 0.6em;\r\n        height: 45px;\r\n    }\r\n\r\n    #company-location-map {\r\n        width: 86%;\r\n        height: 350px;\r\n        max-width: none;\r\n        min-width: auto;\r\n        padding: 0;\r\n        margin: 15px 0 50px 7%;\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 200px) {\r\n    #question-container {\r\n        font-size: 0.45em;\r\n        height: 35px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
